import { UserMinus, TrendUp } from "@phosphor-icons/react";

// Metadata for KPI deep-link filters (Dashboard cards → ClientsPage banner).
// Adding a new filter requires:
//  1. The matching key in this object (label, description, icon, accent)
//  2. A `filter_ids` source in DashboardPage (e.g. inactive_clients.client_ids)
//  3. A KpiCard link in DashboardPage with `?filter=<key>`
export const FILTER_META = {
  inactive: {
    label: "Inattivi",
    description: "Nessun aggiornamento da 7+ giorni",
    icon: UserMinus,
    accent: "#FF9500",
  },
  improving: {
    label: "In miglioramento",
    description: "Trend volume positivo negli ultimi 30 giorni",
    icon: TrendUp,
    accent: "#34C759",
  },
};
